export function StudentFillIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M12.486 4.126a1 1 0 00-.972 0l-9 5A1 1 0 002 10v7.5a1 1 0 102 0v-5.734l3 1.8v3.409c0 .227.072.45.206.634 2.367 3.254 7.22 3.255 9.588 0 .134-.185.206-.407.206-.634v-3.409l4.515-2.709a1 1 0 00-.03-1.731l-9-5z"
      ></path>
    </svg>
  );
}
